import React from "react";
import { Text } from "@sede-enterprise/shell-ds-react-framework";
import { BaseModal } from "./ConfirmationModal";
import { formatNumberWithCommas } from "../utils";
import { ISourceAuction } from "../../../services";

interface NoQuantityModalProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Modal to display when no quantity has been entered for return
 */
export const NoQuantityModal: React.FC<NoQuantityModalProps> = ({
  open,
  onClose,
}) => {
  return (
    <BaseModal
      open={open}
      title="No Quantity Entered"
      onClose={onClose}
      actions={[
        {
          label: "Close",
          action: onClose,
        },
      ]}
    >
      <div style={{ marginBottom: "20px" }}>
        <Text size="medium">
          Please enter the quantity of the capacity to return.
        </Text>
      </div>
    </BaseModal>
  );
};

interface ExceedsCapacityModalProps {
  open: boolean;
  onClose: () => void;
  editingAuctionId: string | null;
  rowData: ISourceAuction[];
}

/**
 * Modal to display when entered quantity exceeds available capacity
 */
export const ExceedsCapacityModal: React.FC<ExceedsCapacityModalProps> = ({
  open,
  onClose,
  editingAuctionId,
  rowData,
}) => {
  const getAuctionData = () => {
    if (!editingAuctionId) return null;
    
    return rowData.find(
      (auction: ISourceAuction) => auction.auctionId === editingAuctionId
    );
  };

  const auctionData = getAuctionData();
  const maxCapacity = auctionData?.availableAllocatedCapacity || 0;

  return (
    <BaseModal
      open={open}
      title="Quantity to Return Exceeds Capacity"
      onClose={onClose}
      actions={[
        {
          label: "Close",
          action: onClose,
        },
      ]}
    >
      <div style={{ marginBottom: "20px" }}>
        <Text size="medium" style={{ color: "#dc3545" }}>
          The quantity you entered exceeds the available capacity!
        </Text>
        <br />
        {auctionData && (
          <>
            <Text size="medium">
              Source auction: {auctionData.auctionName}
            </Text>
            <Text size="medium">
              Available capacity: {formatNumberWithCommas(maxCapacity)} MW
            </Text>
          </>
        )}
      </div>
    </BaseModal>
  );
};